import { ITicket, TicketSilo } from "interfaces/entities/ticket";
import { ITicketSorting } from "interfaces/sorting";
import { Action } from "services/websocket/interfaces";
import { IEntityDeleteFailure, IEntityUpdateFailure } from "store/entities/actions";
import { IFetchClosestTicketInfoPayload } from "store/entities/tickets/interfaces";
import { ActionsUnion, IAction, IActionWithPayload, createAction } from "store/helper";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  IMergeTicketsDonePayload,
  IMergeTicketsPayload,
  INotifyTicketAgentActivityPayload,
  IOnTicketUpdatedPayload,
  IPerformBulkActionDonePayload,
  IPerformBulkActionPayload,
  IPerformBulkSiloChangeDonePayload,
  IPerformBulkSiloChangePayload,
  ITicketsViewAddFollowerPayload,
  ITicketsViewBatchUpdatePayload,
  ITicketsViewBatchUpdateSuccessPayload,
  ITicketsViewClearDraftPayload,
  ITicketsViewCreateTicketPayload,
  ITicketsViewDeleteFollowerPayload,
  ITicketsViewFetchOriginalMessage,
  ITicketsViewFetchOriginalMessageFailure,
  ITicketsViewFetchOriginalMessageSuccess,
  ITicketsViewFromAllTeamsPayload,
  ITicketsViewNavigationItemCount,
  ITicketsViewSaveDraftPayload,
  ITicketsViewSelectCustomViewPayload,
  ITicketsViewSelectStandardViewPayload,
  ITicketsViewSendMessagePayload,
  ITicketsViewSetQueryParams,
  ITicketsViewSetRoutePayload,
  ITicketsViewSetTicketsDataPayload,
  ITicketsViewSetViewPayload,
  ITicketsViewUnspamPayload,
  ITicketsViewUpdateAssignedTeamPayload,
  ITicketsViewUpdateAssigneePayload,
  ITicketsViewUpdateFilterPayload,
  ITicketsViewUpdatePriorityPayload,
  ITicketsViewUpdateRequesterPayload,
  ITicketsViewUpdateStatusPayload,
  ITicketsViewUpdateTagsPayload,
  TicketAgentActivityType,
} from "./interfaces";

export const FETCH_UNSTRIPPED = "VIEWS/TICKETS/FETCH_UNSTRIPPED_MESSAGE";
export const FETCH_ORIGINAL = "VIEWS/TICKETS/FETCH_ORIGINAL_MESSAGE";

export enum TicketsViewActionsNames {
  SET_INITIAL_ROUTE = "VIEWS/TICKETS/SET_INITIAL_ROUTE",
  SET_FOCUSED_COLUMN = "VIEWS/TICKETS/SET_FOCUSED_COLUMN",
  SET_FETCHED_ROUTE = "VIEWS/TICKETS/SET_FETCHED_ROUTE",
  SET_DATA = "VIEWS/TICKETS/SET_DATA",
  SET_PAGE = "VIEWS/TICKETS/SET_PAGE",
  TICKET_UPDATED = "VIEWS/TICKETS/TICKET_UPDATED",
  UPDATE_FILTER = "VIEWS/TICKETS/UPDATE_FILTER",
  SET_QUERY_PARAMS = "VIEWS/TICKETS/SET_QUERY_PARAMS",
  SET_VIEW = "VIEWS/TICKETS/SET_VIEW",
  SELECT_CUSTOM_VIEW = "VIEWS/TICKETS/SELECT_CUSTOM_VIEW",
  SELECT_STANDARD_VIEW = "VIEWS/TICKETS/SELECT_STANDARD_VIEW",
  UPDATE_TAGS = "VIEWS/TICKETS/UPDATE_TAGS",
  SELECT_TICKETS = "VIEWS/TICKETS/SELECT",
  UPDATE_BATCH = "VIEWS/TICKETS/UPDATE_BATCH_REQUEST",
  UPDATE_BATCH_SUCCESS = "VIEWS/TICKETS/UPDATE_BATCH_SUCCESS",
  UPDATE_BATCH_FAILURE = "VIEWS/TICKETS/UPDATE_BATCH_FAILURE",
  SET_SEARCH_QUERY = "VIEWS/TICKETS/SET_SEARCH_QUERY",
  CLEAR_SEARCH_QUERY = "VIEWS/TICKETS/CLEAR_SEARCH",
  SET_SILO = "VIEWS/TICKETS/SET_SILO",
  RESET_SELECTED_TICKETS = "VIEWS/TICKETS/RESET_SELECTED_TICKETS",
  SYNC_DELETE = "VIEWS/TICKETS/SYNC_DELETE",
  UPDATE_PRIORITY = "VIEWS/TICKETS/UPDATE_PRIORITY",
  UPDATE_STATUS = "VIEWS/TICKETS/UPDATE_STATUS",
  UPDATE_CURRENT_SORTING = "VIEWS/TICKETS/UPDATE_CURRENT_SORTING",
  RESET_CURRENT_SORTING = "VIEWS/TICKETS/RESET_CURRENT_SORTING",

  // single ticket
  CREATE_TICKET = "VIEWS/TICKETS/CREATE_TICKET",
  FETCH_SINGLE = "VIEWS/TICKETS/FETCH_SINGLE",
  FETCH_CLOSEST_TICKET = "VIEWS/TICKETS/FETCH_CLOSEST_TICKET",
  DELETE_TICKET = "VIEWS/TICKETS/DELETE_TICKET",
  SET_CURRENT_ITEM = "VIEWS/TICKETS/SET_CURRENT_ITEM",
  UPDATE_SUBJECT = "VIEWS/TICKETS/UPDATE_SUBJECT",
  UPDATE_REQUESTER = "VIEWS/TICKETS/UPDATE_REQUESTER",
  UPDATE_CCS = "VIEWS/TICKETS/UPDATE_CCS",
  UPDATE_ASSIGNEE = "VIEWS/TICKETS/UPDATE_ASSIGNEE",
  UPDATE_ASSIGNED_TEAM = "VIEWS/TICKETS/UPDATE_ASSIGNED_TEAM",
  SEND_MESSAGE = "VIEWS/TICKETS/SEND_MESSAGE",
  SAVE_DRAFT = "VIEWS/TICKETS/SAVE_DRAFT",
  CLEAR_DRAFT = "VIEWS/TICKETS/CLEAR_DRAFT",
  UNSPAM = "VIEWS/TICKETS/UNSPAM",
  COPY_TICKET_URL = "VIEWS/TICKETS/COPY_TICKET_URL",
  COPY_REQUESTER_EMAIL = "VIEWS/TICKETS/COPY_REQUESTER_EMAIL",
  SHOW_FROM_ALL_TEAMS = "VIEWS/TICKETS/SHOW_FROM_ALL_TEAMS",

  // custom views
  UPDATE_CUSTOM_VIEW = "VIEWS/TICKETS/UPDATE_CUSTOM_VIEW",
  CREATE_CUSTOM_VIEW = "VIEWS/TICKETS/CREATE_CUSTOM_VIEW",

  // navigation items
  SET_NAVIGATION_ITEM_COUNT = "VIEWS/TICKETS/SET_NAVIGATION_ITEM_COUNT",

  // fetching original message
  FETCH_ORIGINAL_MESSAGE = `${FETCH_ORIGINAL}_REQUEST`,
  FETCH_ORIGINAL_MESSAGE_SUCCESS = `${FETCH_ORIGINAL}_SUCCESS`,
  FETCH_ORIGINAL_MESSAGE_FAILURE = `${FETCH_ORIGINAL}_FAILURE`,

  // fetching unstripped content
  FETCH_UNSTRIPPED_MESSAGE = `${FETCH_UNSTRIPPED}_REQUEST`,
  FETCH_UNSTRIPPED_MESSAGE_SUCCESS = `${FETCH_UNSTRIPPED}_SUCCESS`,
  FETCH_UNSTRIPPED_MESSAGE_FAILURE = `${FETCH_UNSTRIPPED}_FAILURE`,

  // controlling followers
  ADD_FOLLOWER = "VIEWS/TICKETS/ADD_FOLLOWER",
  ADD_FOLLOWER_SUCCESS = "VIEWS/TICKETS/ADD_FOLLOWER_SUCCESS",
  ADD_FOLLOWER_FAILURE = "VIEWS/TICKETS/ADD_FOLLOWER_FAILURE",

  DELETE_FOLLOWER = "VIEWS/TICKETS/DELETE_FOLLOWER",
  DELETE_FOLLOWER_SUCCESS = "VIEWS/TICKETS/DELETE_FOLLOWER_SUCCESS",
  DELETE_FOLLOWER_FAILURE = "VIEWS/TICKETS/DELETE_FOLLOWER_FAILURE",

  REFRESH_TICKETS = "VIEWS/TICKETS/REFRESH_TICKETS",

  SUBSCRIBE_TICKET_ACTIVITIES = "VIEWS/TICKETS/SUBSCRIBE_TICKET_ACTIVITIES",
  UNSUBSCRIBE_TICKET_ACTIVITIES = "VIEWS/TICKETS/UNSUBSCRIBE_TICKET_ACTIVITIES",
  NOTIFY_TICKET_ACTIVITY = "VIEWS/TICKETS/NOTIFY_TICKET_ACTIVITY",

  PERFORM_BULK_ACTION = "VIEWS/TICKETS/PERFORM_BULK_ACTION",
  PERFORM_BULK_ACTION_DONE = "VIEWS/TICKETS/PERFORM_BULK_ACTION_DONE",

  PERFORM_BULK_DELETE = "VIEWS/TICKETS/PERFORM_BULK_DELETE",
  PERFORM_BULK_DELETE_DONE = "VIEWS/TICKETS/PERFORM_BULK_DELETE_DONE",

  PERFORM_BULK_SILO_CHANGE = "VIEWS/TICKETS/PERFORM_BULK_SILO_CHANGE",
  PERFORM_BULK_SILO_CHANGE_DONE = "VIEWS/TICKETS/PERFORM_BULK_SILO_CHANGE_DONE",

  // merging tickets
  MERGE_TICKETS = "VIEWS/TICKETS/MERGE_TICKETS",
  MERGE_TICKETS_DONE = "VIEWS/TICKETS/MERGE_TICKETS_DONE",
}

export const TicketsViewActions = {
  // tickets list
  setInitialRoute: (
    payload: ITicketsViewSetRoutePayload
  ): IActionWithPayload<TicketsViewActionsNames.SET_INITIAL_ROUTE, ITicketsViewSetRoutePayload> =>
    createAction(TicketsViewActionsNames.SET_INITIAL_ROUTE, payload),

  setFocusedColumn: (
    focusedColumn: number
  ): IActionWithPayload<TicketsViewActionsNames.SET_FOCUSED_COLUMN, { focusedColumn: number }> =>
    createAction(TicketsViewActionsNames.SET_FOCUSED_COLUMN, { focusedColumn }),

  setTicketsData: (
    payload: ITicketsViewSetTicketsDataPayload
  ): IActionWithPayload<TicketsViewActionsNames.SET_DATA, ITicketsViewSetTicketsDataPayload> =>
    createAction(TicketsViewActionsNames.SET_DATA, payload),
  onTicketUpdated: (
    ticketId: string,
    action?: Action,
    ticket?: ITicket
  ): IActionWithPayload<TicketsViewActionsNames.TICKET_UPDATED, IOnTicketUpdatedPayload> =>
    createAction(TicketsViewActionsNames.TICKET_UPDATED, { ticketId, action, ticket }),

  setPage: (page: number): IActionWithPayload<TicketsViewActionsNames.SET_PAGE, { page: number }> =>
    createAction(TicketsViewActionsNames.SET_PAGE, { page }),

  refreshTickets: (): IActionWithPayload<TicketsViewActionsNames.REFRESH_TICKETS, Record<string, never>> =>
    createAction(TicketsViewActionsNames.REFRESH_TICKETS, {}),

  updateFilter: (
    payload: ITicketsViewUpdateFilterPayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_FILTER, ITicketsViewUpdateFilterPayload> =>
    createAction(TicketsViewActionsNames.UPDATE_FILTER, payload),

  setView: (
    payload: ITicketsViewSetViewPayload
  ): IActionWithPayload<TicketsViewActionsNames.SET_VIEW, ITicketsViewSetViewPayload> =>
    createAction(TicketsViewActionsNames.SET_VIEW, payload),

  setQueryParams: (
    payload: ITicketsViewSetQueryParams
  ): IActionWithPayload<TicketsViewActionsNames.SET_QUERY_PARAMS, ITicketsViewSetQueryParams> =>
    createAction(TicketsViewActionsNames.SET_QUERY_PARAMS, payload),
  selectCustomView: (
    payload: ITicketsViewSelectCustomViewPayload
  ): IActionWithPayload<TicketsViewActionsNames.SELECT_CUSTOM_VIEW, ITicketsViewSelectCustomViewPayload> =>
    createAction(TicketsViewActionsNames.SELECT_CUSTOM_VIEW, payload),
  selectStandardView: (
    payload: ITicketsViewSelectStandardViewPayload
  ): IActionWithPayload<TicketsViewActionsNames.SELECT_STANDARD_VIEW, ITicketsViewSelectStandardViewPayload> =>
    createAction(TicketsViewActionsNames.SELECT_STANDARD_VIEW, payload),
  updateTags: (
    payload: ITicketsViewUpdateTagsPayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_TAGS, ITicketsViewUpdateTagsPayload> =>
    createAction(TicketsViewActionsNames.UPDATE_TAGS, payload),
  updatePriority: (
    payload: ITicketsViewUpdatePriorityPayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_PRIORITY, ITicketsViewUpdatePriorityPayload> =>
    createAction(TicketsViewActionsNames.UPDATE_PRIORITY, payload),
  selectTicketIds: (
    ticketIds: string[]
  ): IActionWithPayload<TicketsViewActionsNames.SELECT_TICKETS, { ticketIds: string[] }> =>
    createAction(TicketsViewActionsNames.SELECT_TICKETS, { ticketIds }),
  updateBatch: (
    payload: ITicketsViewBatchUpdatePayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_BATCH, ITicketsViewBatchUpdatePayload> =>
    createAction(TicketsViewActionsNames.UPDATE_BATCH, payload),
  updateBatchSuccess: (
    payload: ITicketsViewBatchUpdateSuccessPayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_BATCH_SUCCESS, ITicketsViewBatchUpdatePayload> =>
    createAction(TicketsViewActionsNames.UPDATE_BATCH_SUCCESS, payload),

  updateBatchFailure: (payload: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }): IActionWithPayload<TicketsViewActionsNames.UPDATE_BATCH_FAILURE, { error: any }> =>
    createAction(TicketsViewActionsNames.UPDATE_BATCH_FAILURE, payload),

  setSearchQuery: (query: string): IActionWithPayload<TicketsViewActionsNames.SET_SEARCH_QUERY, { query: string }> =>
    createAction(TicketsViewActionsNames.SET_SEARCH_QUERY, { query }),
  clearSearchQuery: (): IAction<TicketsViewActionsNames.CLEAR_SEARCH_QUERY> =>
    createAction(TicketsViewActionsNames.CLEAR_SEARCH_QUERY),
  setSilo: (silo: TicketSilo): IActionWithPayload<TicketsViewActionsNames.SET_SILO, { silo: TicketSilo }> =>
    createAction(TicketsViewActionsNames.SET_SILO, { silo }),
  resetSelectedTickets: (): IAction<TicketsViewActionsNames.RESET_SELECTED_TICKETS> =>
    createAction(TicketsViewActionsNames.RESET_SELECTED_TICKETS),
  syncDelete: (id: string): IActionWithPayload<TicketsViewActionsNames.SYNC_DELETE, { id: string }> =>
    createAction(TicketsViewActionsNames.SYNC_DELETE, { id }),
  // single ticket
  createTicket: (
    payload: ITicketsViewCreateTicketPayload
  ): IActionWithPayload<TicketsViewActionsNames.CREATE_TICKET, ITicketsViewCreateTicketPayload> =>
    createAction(TicketsViewActionsNames.CREATE_TICKET, payload),
  fetchSingle: (
    id: string,
    overwriteCurrent = false
  ): IActionWithPayload<TicketsViewActionsNames.FETCH_SINGLE, { id: string; overwriteCurrent: boolean }> =>
    createAction(TicketsViewActionsNames.FETCH_SINGLE, { id, overwriteCurrent }),
  fetchClosestTicket: (
    payload: IFetchClosestTicketInfoPayload
  ): IActionWithPayload<TicketsViewActionsNames.FETCH_CLOSEST_TICKET, IFetchClosestTicketInfoPayload> =>
    createAction(TicketsViewActionsNames.FETCH_CLOSEST_TICKET, payload),
  deleteTicket: (
    id: string,
    shouldRedirect?: boolean
  ): IActionWithPayload<TicketsViewActionsNames.DELETE_TICKET, { id: string; shouldRedirect: boolean | undefined }> =>
    createAction(TicketsViewActionsNames.DELETE_TICKET, { id, shouldRedirect }),
  setCurrentItem: (
    ticket: ITicket
  ): IActionWithPayload<TicketsViewActionsNames.SET_CURRENT_ITEM, { ticket: ITicket }> =>
    createAction(TicketsViewActionsNames.SET_CURRENT_ITEM, { ticket }),
  updateSubject: (
    ticketId: string,
    subject: string
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_SUBJECT, { ticketId: string; subject: string }> =>
    createAction(TicketsViewActionsNames.UPDATE_SUBJECT, { ticketId, subject }),
  updateRequester: (
    ticketId: string,
    requesterName: string,
    requesterEmail: string
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_REQUESTER, ITicketsViewUpdateRequesterPayload> =>
    createAction(TicketsViewActionsNames.UPDATE_REQUESTER, { ticketId, requesterName, requesterEmail }),
  updateCCs: (
    ticketId: string,
    ccs: string[]
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_CCS, { ticketId: string; ccs: string[] }> =>
    createAction(TicketsViewActionsNames.UPDATE_CCS, { ticketId, ccs }),
  updateAssignee: (
    payload: ITicketsViewUpdateAssigneePayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_ASSIGNEE, ITicketsViewUpdateAssigneePayload> =>
    createAction(TicketsViewActionsNames.UPDATE_ASSIGNEE, payload),
  updateAssignedTeam: (
    payload: ITicketsViewUpdateAssignedTeamPayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_ASSIGNED_TEAM, ITicketsViewUpdateAssignedTeamPayload> =>
    createAction(TicketsViewActionsNames.UPDATE_ASSIGNED_TEAM, payload),
  sendMessage: (
    payload: ITicketsViewSendMessagePayload
  ): IActionWithPayload<TicketsViewActionsNames.SEND_MESSAGE, ITicketsViewSendMessagePayload> =>
    createAction(TicketsViewActionsNames.SEND_MESSAGE, payload),
  saveDraft: (
    payload: ITicketsViewSaveDraftPayload
  ): IActionWithPayload<TicketsViewActionsNames.SAVE_DRAFT, ITicketsViewSaveDraftPayload> =>
    createAction(TicketsViewActionsNames.SAVE_DRAFT, payload),
  clearDraft: (
    payload: ITicketsViewClearDraftPayload
  ): IActionWithPayload<TicketsViewActionsNames.CLEAR_DRAFT, ITicketsViewClearDraftPayload> =>
    createAction(TicketsViewActionsNames.CLEAR_DRAFT, payload),
  unspam: (
    payload: ITicketsViewUnspamPayload
  ): IActionWithPayload<TicketsViewActionsNames.UNSPAM, ITicketsViewUnspamPayload> =>
    createAction(TicketsViewActionsNames.UNSPAM, payload),
  copyTicketUrl: (): IAction<TicketsViewActionsNames.COPY_TICKET_URL> =>
    createAction(TicketsViewActionsNames.COPY_TICKET_URL),
  copyRequesterEmail: (): IAction<TicketsViewActionsNames.COPY_REQUESTER_EMAIL> =>
    createAction(TicketsViewActionsNames.COPY_REQUESTER_EMAIL),
  showTicketsFromAllTeams: (
    payload: ITicketsViewFromAllTeamsPayload
  ): IActionWithPayload<TicketsViewActionsNames.SHOW_FROM_ALL_TEAMS, ITicketsViewFromAllTeamsPayload> =>
    createAction(TicketsViewActionsNames.SHOW_FROM_ALL_TEAMS, payload),
  updateCustomView: (): IAction<TicketsViewActionsNames.UPDATE_CUSTOM_VIEW> =>
    createAction(TicketsViewActionsNames.UPDATE_CUSTOM_VIEW),
  createCustomView: (
    name: string,
    shared?: boolean
  ): IActionWithPayload<TicketsViewActionsNames.CREATE_CUSTOM_VIEW, { name: string; shared: boolean | undefined }> =>
    createAction(TicketsViewActionsNames.CREATE_CUSTOM_VIEW, { name, shared }),
  setNavigationItemCount: (
    payload: ITicketsViewNavigationItemCount
  ): IActionWithPayload<TicketsViewActionsNames.SET_NAVIGATION_ITEM_COUNT, ITicketsViewNavigationItemCount> =>
    createAction(TicketsViewActionsNames.SET_NAVIGATION_ITEM_COUNT, payload),
  fetchOriginalMessage: (
    payload: ITicketsViewFetchOriginalMessage
  ): IActionWithPayload<TicketsViewActionsNames.FETCH_ORIGINAL_MESSAGE, ITicketsViewFetchOriginalMessage> =>
    createAction(TicketsViewActionsNames.FETCH_ORIGINAL_MESSAGE, payload),
  fetchOriginalMessageSuccess: (
    payload: ITicketsViewFetchOriginalMessageSuccess
  ): IActionWithPayload<
    TicketsViewActionsNames.FETCH_ORIGINAL_MESSAGE_SUCCESS,
    ITicketsViewFetchOriginalMessageSuccess
  > => createAction(TicketsViewActionsNames.FETCH_ORIGINAL_MESSAGE_SUCCESS, payload),
  fetchOriginalMessageFailure: (
    payload: ITicketsViewFetchOriginalMessageFailure
  ): IActionWithPayload<
    TicketsViewActionsNames.FETCH_ORIGINAL_MESSAGE_FAILURE,
    ITicketsViewFetchOriginalMessageFailure
  > => createAction(TicketsViewActionsNames.FETCH_ORIGINAL_MESSAGE_FAILURE, payload),
  fetchUnstrippedMessage: (
    payload: ITicketsViewFetchOriginalMessage
  ): IActionWithPayload<TicketsViewActionsNames.FETCH_UNSTRIPPED_MESSAGE, ITicketsViewFetchOriginalMessage> =>
    createAction(TicketsViewActionsNames.FETCH_UNSTRIPPED_MESSAGE, payload),
  fetchUnstrippedMessageSuccess: (
    payload: ITicketsViewFetchOriginalMessageSuccess
  ): IActionWithPayload<
    TicketsViewActionsNames.FETCH_UNSTRIPPED_MESSAGE_SUCCESS,
    ITicketsViewFetchOriginalMessageSuccess
  > => createAction(TicketsViewActionsNames.FETCH_UNSTRIPPED_MESSAGE_SUCCESS, payload),
  fetchUnstrippedMessageFailure: (
    payload: ITicketsViewFetchOriginalMessageFailure
  ): IActionWithPayload<
    TicketsViewActionsNames.FETCH_UNSTRIPPED_MESSAGE_FAILURE,
    ITicketsViewFetchOriginalMessageFailure
  > => createAction(TicketsViewActionsNames.FETCH_UNSTRIPPED_MESSAGE_FAILURE, payload),
  updateStatus: (
    payload: ITicketsViewUpdateStatusPayload
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_STATUS, ITicketsViewUpdateStatusPayload> =>
    createAction(TicketsViewActionsNames.UPDATE_STATUS, payload),
  addFollower: (
    payload: ITicketsViewAddFollowerPayload
  ): IActionWithPayload<TicketsViewActionsNames.ADD_FOLLOWER, ITicketsViewAddFollowerPayload> =>
    createAction(TicketsViewActionsNames.ADD_FOLLOWER, payload),
  addFollowerSuccess: (): IActionWithPayload<TicketsViewActionsNames.ADD_FOLLOWER_SUCCESS, Record<string, never>> =>
    createAction(TicketsViewActionsNames.ADD_FOLLOWER_SUCCESS, {}),
  addFollowerFailure: (
    payload: IEntityUpdateFailure
  ): IActionWithPayload<TicketsViewActionsNames.ADD_FOLLOWER_FAILURE, IEntityUpdateFailure> =>
    createAction(TicketsViewActionsNames.ADD_FOLLOWER_FAILURE, payload),
  deleteFollower: (
    payload: ITicketsViewDeleteFollowerPayload
  ): IActionWithPayload<TicketsViewActionsNames.DELETE_FOLLOWER, ITicketsViewDeleteFollowerPayload> =>
    createAction(TicketsViewActionsNames.DELETE_FOLLOWER, payload),
  deleteFollowerSuccess: (): IAction<TicketsViewActionsNames.DELETE_FOLLOWER_SUCCESS> =>
    createAction(TicketsViewActionsNames.DELETE_FOLLOWER_SUCCESS),
  deleteFollowerFailure: (
    payload: IEntityDeleteFailure
  ): IActionWithPayload<TicketsViewActionsNames.DELETE_FOLLOWER_FAILURE, IEntityDeleteFailure> =>
    createAction(TicketsViewActionsNames.DELETE_FOLLOWER_FAILURE, payload),
  subscribeTicketActivities: (): IActionWithPayload<
    TicketsViewActionsNames.SUBSCRIBE_TICKET_ACTIVITIES,
    Record<string, never>
  > => createAction(TicketsViewActionsNames.SUBSCRIBE_TICKET_ACTIVITIES, {}),
  unsubscribeTicketActivities: (): IActionWithPayload<
    TicketsViewActionsNames.UNSUBSCRIBE_TICKET_ACTIVITIES,
    Record<string, never>
  > => createAction(TicketsViewActionsNames.UNSUBSCRIBE_TICKET_ACTIVITIES, {}),
  notifyViewing: (
    ticketID: string
  ): IActionWithPayload<TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, INotifyTicketAgentActivityPayload> =>
    createAction(TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, {
      agentActivity: TicketAgentActivityType.ViewingStart,
      ticketID,
    }),
  notifyViewingStopped: (
    ticketID: string
  ): IActionWithPayload<TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, INotifyTicketAgentActivityPayload> =>
    createAction(TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, {
      agentActivity: TicketAgentActivityType.ViewingStop,
      ticketID,
    }),
  notifyTyping: (
    ticketID: string
  ): IActionWithPayload<TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, INotifyTicketAgentActivityPayload> =>
    createAction(TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, {
      agentActivity: TicketAgentActivityType.TypingStart,
      ticketID,
    }),
  notifyTypingStop: (
    ticketID: string
  ): IActionWithPayload<TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, INotifyTicketAgentActivityPayload> =>
    createAction(TicketsViewActionsNames.NOTIFY_TICKET_ACTIVITY, {
      agentActivity: TicketAgentActivityType.TypingStop,
      ticketID,
    }),
  performBulkAction: (
    payload: IPerformBulkActionPayload
  ): IActionWithPayload<TicketsViewActionsNames.PERFORM_BULK_ACTION, IPerformBulkActionPayload> =>
    createAction(TicketsViewActionsNames.PERFORM_BULK_ACTION, payload),
  performBulkActionDone: (
    successCount: number,
    failureCount: number
  ): IActionWithPayload<TicketsViewActionsNames.PERFORM_BULK_ACTION_DONE, IPerformBulkActionDonePayload> =>
    createAction(TicketsViewActionsNames.PERFORM_BULK_ACTION_DONE, { successCount, failureCount }),
  performBulkDelete: (
    selectedIds: string[]
  ): IActionWithPayload<TicketsViewActionsNames.PERFORM_BULK_DELETE, { selectedIds: string[] }> =>
    createAction(TicketsViewActionsNames.PERFORM_BULK_DELETE, { selectedIds }),
  performBulkDeleteDone: (
    successCount: number,
    failureCount: number
  ): IActionWithPayload<TicketsViewActionsNames.PERFORM_BULK_DELETE_DONE, IPerformBulkActionDonePayload> =>
    createAction(TicketsViewActionsNames.PERFORM_BULK_DELETE_DONE, { successCount, failureCount }),
  performBulkSiloChange: (
    selectedIds: string[],
    newSilo: TicketSilo
  ): IActionWithPayload<TicketsViewActionsNames.PERFORM_BULK_SILO_CHANGE, IPerformBulkSiloChangePayload> =>
    createAction(TicketsViewActionsNames.PERFORM_BULK_SILO_CHANGE, { selectedIds, newSilo }),
  performBulkSiloChangeDone: (
    successCount: number,
    failureCount: number,
    silo: TicketSilo
  ): IActionWithPayload<TicketsViewActionsNames.PERFORM_BULK_SILO_CHANGE_DONE, IPerformBulkSiloChangeDonePayload> =>
    createAction(TicketsViewActionsNames.PERFORM_BULK_SILO_CHANGE_DONE, { successCount, failureCount, silo }),
  mergeTickets: (
    payload: IMergeTicketsPayload
  ): IActionWithPayload<TicketsViewActionsNames.MERGE_TICKETS, IMergeTicketsPayload> =>
    createAction(TicketsViewActionsNames.MERGE_TICKETS, payload),
  mergeTicketsDone: (
    successCount: number,
    failureCount: number,
    onFinish: () => void
  ): IActionWithPayload<TicketsViewActionsNames.MERGE_TICKETS_DONE, IMergeTicketsDonePayload> =>
    createAction(TicketsViewActionsNames.MERGE_TICKETS_DONE, { successCount, failureCount, onFinish }),
  updateCurrentSorting: (
    payload: ITicketSorting
  ): IActionWithPayload<TicketsViewActionsNames.UPDATE_CURRENT_SORTING, ITicketSorting> =>
    createAction(TicketsViewActionsNames.UPDATE_CURRENT_SORTING, payload),
  resetCurrentSorting: (): IAction<TicketsViewActionsNames.RESET_CURRENT_SORTING> =>
    createAction(TicketsViewActionsNames.RESET_CURRENT_SORTING),
};

export type TicketsViewAction = ActionsUnion<typeof TicketsViewActions>;
